export function tokenParser(token) {
    let tokenSections = token.split(".");
    if (tokenSections.length === 3) {
        return JSON.parse(atob(tokenSections[1].replace("-", "+").replace("_", "/")));
        ;
    }
    return false;
}
//# sourceMappingURL=tokenParser.js.map